// extracted by mini-css-extract-plugin
export default {"AccountRecover":"kylVXdm1P2","Container":"yGfUcXWu_8","FormContainer":"iH5tOl3zWZ","SubmitGroup":"yHvtAON7je","ErrorMessage":"wVAy4gZcnm"};